import type { InputHTMLAttributes } from "react";
import { cn } from "./utils";

type AdminControlTone = "default" | "danger" | "warning" | "info";
type AdminControlSize = "sm" | "md";
type AdminControlVariant = "field" | "bare";

interface AdminTextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  tone?: AdminControlTone;
  controlSize?: AdminControlSize;
  variant?: AdminControlVariant;
}

const toneClass: Record<AdminControlTone, string> = {
  default: "border-slate-200 focus:border-blue-500 focus:ring-blue-500",
  danger: "border-rose-200 focus:border-rose-500 focus:ring-rose-500",
  warning: "border-amber-200 focus:border-amber-500 focus:ring-amber-500",
  info: "border-blue-200 focus:border-blue-500 focus:ring-blue-500",
};

const sizeClass: Record<AdminControlSize, string> = {
  sm: "h-8 px-2",
  md: "h-9 px-2.5",
};

const AdminTextInput = ({ tone = "default", controlSize = "md", variant = "field", className, ...props }: AdminTextInputProps) => (
  <input
    className={cn(
      "w-full text-xs text-slate-700 outline-none transition-colors placeholder:text-slate-400 disabled:cursor-not-allowed disabled:text-slate-400",
      variant === "field" && "rounded-lg border bg-white focus:ring-1 disabled:bg-slate-50",
      variant === "field" && toneClass[tone],
      variant === "field" && sizeClass[controlSize],
      variant === "bare" && "border-0 bg-transparent p-0 focus:ring-0",
      className,
    )}
    {...props}
  />
);

export default AdminTextInput;
